import iconPath from '@/assets/device-icons/iphone-15-pro.svg';

interface Iphone15ProIconProps {
  className?: string;
}

export const Iphone15ProIcon = ({ className = "h-5 w-5" }: Iphone15ProIconProps) => {
  return (
    <img 
      src={iconPath} 
      alt="iPhone 15 Pro" 
      className={className}
    />
  );
};
